import { mapValues } from "lodash-es";
import { match, P } from "ts-pattern";

import yup from "@/yup";

export function useAddBannerFormSchema() {
  return yup.object({
    titles: yup.lazy((value) =>
      yup.object(mapValues(value, () => yup.string().default("").defined())),
    ),
    subtitles: yup.lazy((value) =>
      yup.object(mapValues(value, () => yup.string().default("").defined())),
    ),
    buttons: yup.lazy((value) =>
      yup.object(mapValues(value, () => yup.string().default("").defined())),
    ),
    type: yup
      .mixed<"simple" | "text" | "bonus">()
      .oneOf(["simple", "text", "bonus"])
      .defined(),
    bonusId: yup
      .number()
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .integer(),
    actionType: yup
      .mixed<"url" | "provider" | "tag" | "game" | "category" | null>()
      .oneOf(["url", "provider", "tag", "game", "category", null])
      .defined(),
    actionValue: yup.mixed().when(["actionType"], (actionType) => {
      return match(actionType)
        .with(null, () => yup.mixed().oneOf([null]))
        .with("url", () => yup.string().url().defined())
        .with(P.union("provider", "game", "tag", "category"), () =>
          yup.string().min(1).defined(),
        )
        .exhaustive();
    }),
  });
}

export type AddBannerFormSchema = yup.InferType<
  ReturnType<typeof useAddBannerFormSchema>
>;
